$(document).ready(function(){

  $(document).on("click", "#confirm_legal_document", function(){
    $('.legal_doc').addClass('active');
    $('.general_doc').removeClass('active');
    $( "#legal_documents" ).removeClass( "hide" )
    $( "#general_documents" ).addClass( "hide" )
  });

  $(document).on("click", "#confirm_legal_contract", function(){
    $('.legal_contract').addClass('active');
    $('.general_contract').removeClass('active');
    $( "#legal_contracts" ).removeClass( "hide" )
    $( "#general_contracts" ).addClass( "hide" )
  });

  $(document).on("click", "#confirm_general_document", function(){
    $('.general_doc').addClass('active');
    $('.legal_doc').removeClass('active');
    $( "#legal_documents" ).addClass( "hide" )
    $( "#general_documents" ).removeClass( "hide" )
  });

  $(document).on("click", "#confirm_general_contract", function(){
    $('.general_contract').addClass('active');
    $('.legal_contract').removeClass('active');
    $( "#legal_contracts" ).addClass( "hide" )
    $( "#general_contracts" ).removeClass( "hide" )
  });

  $(document).on('click', '.doc_image_loader', function(){
    $("#doc-image-loader").show();
  });  

  //show document group form on clicking edit group btn
  $(document).on("click", ".document_group_edit", function(){
    var id = getId(this.id);
    $("#document_group_lbl_"+ id).addClass('hide');
    $("#document_group_form_" + id).removeClass('hide');
  });

  //hide document group form on clicking cancel btn
  $(document).on("click", ".document_group_cancel", function(){
    hideDocumentGroupForm(getId(this.id));
  });

  //remove the create document_group/document form when clicked on remove btn
  $(document).on("click", ".document_group_new_remove, .document_new_remove", function(){
    $("#" + getId(this.id)).remove();
  });

  //enable filename box and show save,cancel and remove btns document on clicking edit documment btn
  $(document).on("click", ".document_edit", function(){
    var id = getId(this.id);
    $(this).addClass('hide');
    $("#document_name_" + id).removeClass("hide");
    $("#document_attachment_" + id).removeClass("hide");
    $("#document_file_" + id).addClass("hide");
    $("#document_form_" + id).removeClass("hide");
    $("#document_remove_" + id).removeClass("hide");
    $("#document_cancel_" + id).removeClass("hide");
  });

  $(document).on("change", ".groupDocumentMedia", function(){
    var id = getId(this.id);
    $.each(this.files, function() {
      readURL(this, id);
    });
  });

});

function readURL(file, id) {
  var reader = new FileReader();
  reader.onload = function(e) {
    $("#groupDocumentMediaFileName_" + id).val(file.name);
  }
  reader.readAsDataURL(file);
}

function hideDocumentGroupForm(id) {
  $("#document_group_lbl_" + id).removeClass('hide');
  $("#document_group_form_" + id).addClass('hide');
}

function hideDocumentForm(id) {
  $("#document_edit_" + id).removeClass('hide');
  $("#document_name_" + id).addClass("hide");
  $("#document_file_" + id).removeClass("hide");
  $("#document_form_" + id).addClass("hide");
  $("#document_remove_" + id).addClass("hide");
  $("#document_cancel_" + id).addClass("hide");
}

function getId(id){
  var idArr = id.split("_");
  return idArr[idArr.length - 1];
}